<template>
    <div>
        <div class="col-12 text-right mb-2 pl-0">
            <div class="row position-relative text-right">
                <div class="col-12 pr-0 d-flex justify-content-between align-items-center">
                    <input type="text" class="form-control" v-model="filter" v-on:keyup.enter="onFilterChange()" placeholder="Search" />
                    <div class="">
                        <button @click="OpenFileUpload()" class="mr-2 text-uppercase btn custom-button btn-outline-primary">
                            Excel Upload
                        </button>
                        <button class="btn custom-button btn-primary" id="add-supplier-mapping" text="Add New Supplier Mapping" @click="ShowSupplierMappingForm = true">
                            Add
                        </button>
                    </div>
                </div>
            </div><svg v-b-tooltip class="d-none"></svg>
        </div>
         <div class="col-md-12 px-0">
            <template>
                <div class="common-table">
                    <b-table :per-page="perPage" :items="data.rows"
                                :fields="supplierMappingFields"
                                id="all-items"
                                :no-local-sorting="true" @sort-changed="sortChange"
                                show-empty
                                striped
                                hover
                                responsive
                                class="all-items supplierMapping-table">
                        <template v-slot:cell(UpdatedDate)="data">
                                <div>
                                    {{ data.value | formatDate }}
                                </div>
                            </template>
                        <template v-slot:cell(action)="row">
                            <div class="edit-supplier-mapping" >
                                <a class="m-2" v-b-tooltip.hover.v-dark.top.html="'Edit'" @click="EditSupplierMapping(row.item)" ><b-img class="edit-icon" :src="editIcon"/> </a>
                                <a class="m-2" v-b-tooltip.hover.v-dark.top.html="'Delete'" @click="ShowDeleteSupplierMappingConfirmation(row.item)" ><b-img class="delete-icon" :src="deleteIcon"/> </a>
                            </div>
                        </template>
                        <template slot="custom-foot" v-if="IsPaginationRequired">
                            <b-tr>
                                <b-td class="custom-pagination" colspan="13">
                                    <b-form-select class="records-per-page" v-model="perPage" :options="RecordsPerPageOption"></b-form-select>
                                    <Pagination style="float: right" :per-page="perPage" aria-controls="open-items" v-model="currentPage" :total-rows="TotalRows" first-number last-number />
                                </b-td>
                            </b-tr>
                        </template>
                    </b-table>
                </div>
            </template>
         </div>
         <b-modal v-model="ShowSupplierMappingForm" hide-footer hide-header :no-close-on-backdrop="true">
            <div class="row">
                <div class="col-12 d-flex justify-content-between border-bottom mb-4">
                    <h5 class="modal-title mb-2">{{this.IsEdit ? 'Edit Supplier Mapping' : 'Add Supplier Mapping'}}</h5>
                    <button class="close" @click="HidePopUpForm()"></button>
                </div>
               <div class="col-10 mx-auto">
                    <div class="mb-2">
                        <label>Instance</label>
                        <OmniSelect class="" placeholder="Select Instance" name="Instance" :showLabel="false" label="value" v-model="SupplierMapping.Entity" :options="EntityList"></OmniSelect>
                    </div>
                    <div class="mb-2">
                        <label>Spectra Code</label>
                        <b-form-input v-model="SupplierMapping.SpectraCode" :maxlength="8" placeholder="Enter Spectra Code" id="SpectraCode"></b-form-input>
                    </div>
                    <div class="mb-2">
                        <label>Ignitia/NG Code</label>
                        <b-form-input v-model="SupplierMapping.IgnitiaNGCode" :maxlength="8" placeholder="Enter Ignitia/NG Code" id="IgnitiaNGCode"></b-form-input>
                    </div>
                    <div class="mb-2">
                        <label>Ignitia/Payee Code</label>
                        <b-form-input v-model="SupplierMapping.PayeeCode" :maxlength="8" placeholder="Enter Ignitia/Payee Code" id="PayeeCode"></b-form-input>
                    </div>
                    <div class="text-right my-4">
                        <button class="btn btn-link text-uppercase" @click="HidePopUpForm()">Cancel</button>
                        <button v-if="this.IsEdit" class="text-uppercase btn btn-primary" :disabled="this.$v.$invalid" @click="UpdateSupplierMappingForm()">Update</button>
                        <button v-else class="text-uppercase btn btn-primary" :disabled="this.$v.$invalid" @click="SubmitSupplierMappingForm()">Submit</button>
                    </div>
                </div>
            </div>
        </b-modal>
        <b-modal modal-class="cancel-request" v-model="ShowDeletionConfirmation" dialog-class="cancel-request" :no-close-on-backdrop="true" size="sm">
            <template v-slot:modal-header="{ close }">
                <h5 class="modal-title">Delete Supplier Mapping</h5>
                <button class="close" @click="Cancel()"></button>
            </template>
            <p class="cancel-info-text">
                Are you sure you want to delete the Supplier Mapping: <strong>{{selectedSupplierMapping?.SpectraCode}}</strong>?
            </p>
            <template v-slot:modal-footer>
                <div class="w-100">
                    <b-button variant="primary"   class="float-right" @click="DeleteSupplierMapping()">Yes</b-button>
                    <b-button variant="secondary" class="float-right" @click="Cancel()">No</b-button>
                </div>
            </template>
        </b-modal>

        <b-modal v-model="ShowExcelUpload" size="lg" :no-close-on-backdrop="true">
            <template v-slot:modal-header="{ close }">
                <h5 class="modal-title">Excel Upload</h5>
                <button class="close" @click="CancelExcelUpload()"></button>
            </template>
            <div class="xls-container d-flex justify-content-between supplier-upload-card px-4">
                <div class="download-section xls-section">
                    <strong class="p-0 title">How to upload excel file for Supplier Mapping table:</strong>
                    <ul class="p-0 mt-3 mb-0 number-list d-flex flex-column">
                        <li class="d-flex align-items-center"><span class="number d-flex justify-content-center align-items-center">1</span>
                            <a @click="downloadSupplierMappingUploadTemplate()">Download this template</a>
                        </li>
                        <li class="d-flex align-items-center mb-3"><span class="number d-flex justify-content-center align-items-center">2</span>Add your data to the template file</li>
                        <li class="d-flex align-items-center mb-0"><span class="number d-flex justify-content-center align-items-center">3</span>Upload excel file</li>
                    </ul>
                </div>
                <div class="upload-section xls-section">
                    <!-- <label class="excel-upload-label">Excel Upload</label> -->
                    <div>

                    </div>
                    <vue-dropzone :duplicateCheck="true" v-on:vdropzone-file-added="UploadedToDropzone" v-on:vdropzone-removed-file="RemovedFromDropzone" ref="excelUploadDropzone" id="dropzone" :useCustomSlot="true" class="customdropzone xls-dropzone" :include-styling="false" :options="dropzoneOptions">
                        <div class="dropzone-custom-content">
                            <b-img class="upload-icon mt-1" :src="uploadIcon"/>
                            <p class="drag-and-drop-file-h">
                                <b-img :src="closeFilterIcon" style="
                margin-top: -7px !important;
                font-family: 'Open Sans';
            " />
                                Drag and drop file here or
                                <span class="draganddropspan"> browse </span>
                            </p>
                        </div>
                    </vue-dropzone>
                    <div class="note-section mt-2">
                        <p>Acceptable file type(s): {{ AllowedFileUploadTypes }}.</p>
                    </div>
                </div>
            </div>
            <template v-slot:modal-footer="{ ok, cancel }">
                <div class="text-right">
                    <button class="btn btn-link text-uppercase" @click="CancelExcelUpload()">
                        Cancel
                    </button>
                    <button v-if="ValidXLSDataAdded" :disabled="IsAnyFieldEmpty || HasAnyDuplicate" class="text-uppercase btn custom-button btn-primary" @click="SubmitBulkUploadSupplierMapping()">
                        Upload
                    </button>
                    <button v-else :disabled="!ExcelFileAdded" class="text-uppercase btn custom-button btn-primary" @click="AddSupplierMappingFromExcel()">
                        Add
                    </button>
                </div>
            </template>
            <div v-if="ShowUploadedTable && UploadedSupplierRows.length > 0" class="mt-4">
                <div class="xls-upload-table">
                    <table class="table table-bordered">
                        <thead>
                        <tr>
                            <th>Instance</th>
                            <th>Spectra Code</th>
                            <th>Ignitia/NG Code</th>
                            <th>Ignitia/Payee Code</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, idx) in UploadedSupplierRows" :key="idx">
                                <td class="Instance-list">
                                    <OmniSelect
                                    v-model="row['Instance']"
                                    :options="EntityList"
                                    :class="{'is-invalid': IsEmptyField(row['Instance'])}"
                                    placeholder="Select Instance"
                                    label="label"
                                    value="value"
                                    />
                                    <small v-if="IsEmptyField(row['Instance'])" class="text-danger">Required Field</small>
                                </td>
                                <td>
                                    <b-form-input
                                        v-model="row['Spectra Code']"
                                        :maxlength="8"
                                        :class="{
                                        'is-invalid': (IsEmptyField(row['Spectra Code']) && IsEmptyField(row['Ignitia/NG Code']))|| IsDuplicateField(row['Spectra Code'], 'Spectra Code', row)
                                        }"
                                    />
                                    <small v-if="IsEmptyField(row['Spectra Code']) && IsEmptyField(row['Ignitia/NG Code'])" class="text-danger">Required Field</small>
                                    <small v-if="IsDuplicateField(row['Spectra Code'], 'Spectra Code', row)" class="text-danger">Spectra code already exists</small>
                                </td>
                                <td>
                                    <b-form-input
                                        v-model="row['Ignitia/NG Code']"
                                        :maxlength="8"
                                        :class="{
                                        'is-invalid': (IsEmptyField(row['Spectra Code']) && IsEmptyField(row['Ignitia/NG Code']))|| IsDuplicateField(row['Ignitia/NG Code'], 'Ignitia/NG Code', row)
                                        }"
                                    />
                                    <small v-if="IsEmptyField(row['Spectra Code']) && IsEmptyField(row['Ignitia/NG Code'])" class="text-danger">Required Field</small>
                                    <small v-if="IsDuplicateField(row['Ignitia/NG Code'], 'Ignitia/NG Code', row)" class="text-danger">Ignitia/NG Code already exists</small>
                                </td>
                                <td>
                                    <b-form-input
                                        v-model="row['Ignitia/Payee Code']"
                                        :maxlength="8"
                                        :class="{
                                        'is-invalid': !IsEmptyField(row['Ignitia/NG Code']) && IsEmptyField(row['Ignitia/Payee Code'])
                                        }"
                                    />
                                    <small v-if="!IsEmptyField(row['Ignitia/NG Code']) && IsEmptyField(row['Ignitia/Payee Code'])" class="text-danger">Required Field</small>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </b-modal>
        <b-modal v-model="ShowErrorPopUp" hide-header :no-close-on-backdrop="true" @hidden="CloseErrorPopUp">
            <div class="row">
                <div class="col-12 d-flex justify-content-between border-bottom mb-4">
                    <h5 class="modal-title mb-2">Error</h5>
                    <button class="close" @click="HidePopUpForm()"></button>
                </div>
                <div class="col-12">
                    <div class="error-list-area">
                        <div v-for="(err,idx) in ErrorList" :key="idx"><p class="mb-2">{{ err }}</p></div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import tabtable from "../../mixins/tabtable";
import { required, requiredIf } from "vuelidate/lib/validators";
import { mapGetters } from 'vuex';
import store from "@/store";
import readXlsxFile from "read-excel-file";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import * as AllowedFileUploadExtensions from "../../utilities/AllowedFileUploadExtensions";
import {UpdateRecordsPerPageOption} from "../../utilities/paginationUtils";
const moment = require("moment");
export default {
    components: {
        vueDropzone: vue2Dropzone,
    },
    name: "SupplierMapping",
    mixins: [tabtable],
    validations: {
        SupplierMapping: {
            Entity: { required },
            SpectraCode: {
                required: requiredIf(function () {
                    return this.SupplierMapping.IgnitiaNGCode == null || this.SupplierMapping.IgnitiaNGCode.trim() == "";
                }),
            },
            IgnitiaNGCode : {
                required: requiredIf(function () {
                    return this.SupplierMapping.SpectraCode == null || this.SupplierMapping.SpectraCode.trim() == "";
                }),
            },
            PayeeCode: { 
                required: requiredIf(function () {
                    return this.SupplierMapping.IgnitiaNGCode != null && this.SupplierMapping.IgnitiaNGCode.trim() != "";
                }),
            },
        }
    },
    data() {
        return {
            ExcelFileAdded:false,
            ShowErrorPopUp:false,
            RemovedCurrentFile:false,
            ErrorList:[],
            ValidXLSDataAdded:false,
            ShowUploadedTable:false,
            UploadedSupplierRows: [],
            TotalRows: 0,
            RecordsPerPageOption: [],
            filter: null,
            perPage: 10,
            currentPage: 1,
            AllowedFileUploadTypes: AllowedFileUploadExtensions.ProductFormsExtensions.join(", "),
            dropzoneOptions: {
                init: function () {
                    this.on("maxfilesexceeded", function (file) {
                        this.removeFile(file);
                        alert("Maximum File Upload limit is 1!");
                    });
                },
                accept: function(file, done) {
                    let fileExtension = file.name.split('.').pop().toLowerCase();
                    if (!AllowedFileUploadExtensions.ProductFormsExtensions.includes(fileExtension)) {
                        store.dispatch(
                            "progress/setErrorMessage",
                            `Unsupported file type. Please upload a valid file type.`
                        );
                        this.removeFile(file);
                    } else {
                        done();
                    }
                },
                paramName: "file",
                previewTemplate: this.template(),
                url: `${process.env.VUE_APP_API_ROOT}api/v1/test/`,
                uploadMultiple: false,
                maxFiles: 1,
                minFiles: 1,
                maxFilesize: 10,
                addRemoveLinks: false,
                parallelUploads: 1,
                createImageThumbnails: false,
                autoProcessQueue: false,
            },
            ShowExcelUpload: false,
            IsEdit: false,
            sortBy: "UpdatedDate",
            SupplierMappingData: {
                rows: [],
            },
            selectedSupplierMapping: null,
            supplierMappingFields: [
                { key: 'Entity', label: 'Instance', sortable: true },
                { key: 'SpectraCode', label: 'Spectra Code' , sortable: true},
                { key: 'IgnitiaNGCode', label: 'Ignitia/NG Code', sortable: true },
                { key: 'PayeeCode', label: 'Ignitia/Payee Code', sortable: true },
                { key: 'UpdatedBy', label: 'Updated By' , sortable: true},
                { key: 'UpdatedDate', label: 'Updated Date', sortable: true },
                { key: 'action', label: 'Action' },
            ],
            editIcon: require("@/assets/Icons/edit.svg"),
            deleteIcon: require("@/assets/Icons/delete.svg"),
            uploadIcon: require("@/assets/Icons/Upload-excel.svg"),
            ShowSupplierMappingForm: false,
            ShowDeletionConfirmation: false,
            EntityList: [
                { value: 'Omnicom Media', label: 'Omnicom Media' },
                { value: 'Zimmerman', label: 'Zimmerman' },
            ],
            data: {
                config: {
                    card_mode: false,
                    show_refresh_button: false,
                    show_reset_button: false,
                    pagination_info: true,
                    global_search: {
                        visibility: false,
                    },
                },
                loading: false,
                classes: {
                    tableWrapper: "outer-table-div-class wrapper-class-two grid-table",
                    table: {
                        "table-sm": true,
                    },
                },
                rows: [],
            },
            reachUserData: null,
            timer: null
        }
    },
    props: {
        activeTab: {
            type: String,
            default: null
        }
    },
    mounted() {
        if (!this.CanAccessList) {
            this.$router.push({
                name: "unauthorized",
                params: {
                    message: "UnAuthorized"
                },
            });
        }
        this.$nextTick(function () {
            window.addEventListener("resize", this.getWindowWidth);
        });
    },
    computed: {
        DuplicateSpectraCodes() {
            const duplicates = [];
            this.UploadedSupplierRows.forEach((row, idx, arr) => {
                if (!row['Instance'] || !row['Spectra Code']) return;
                const code = row['Spectra Code'].trim();
                const instance = row['Instance'].trim();
                const count = arr.filter(r =>
                    (r['Instance'] || '').trim() === instance &&
                    (r['Spectra Code'] || '').trim() === code
                ).length;
                if (count > 1 && !duplicates.includes(code + '|' + instance)) {
                    duplicates.push(code + '|' + instance);
                }
            });
            return duplicates;
        },
        DuplicateIgnitiaNGCodes() {
            const duplicates = [];
            this.UploadedSupplierRows.forEach((row, idx, arr) => {
                if (!row['Instance'] || !row['Ignitia/NG Code']) return;
                const code = row['Ignitia/NG Code'].trim();
                const instance = row['Instance'].trim();
                const count = arr.filter(r =>
                    (r['Instance'] || '').trim() === instance &&
                    (r['Ignitia/NG Code'] || '').trim() === code
                ).length;
                if (count > 1 && !duplicates.includes(code + '|' + instance)) {
                    duplicates.push(code + '|' + instance);
                }
            });
            return duplicates;
        },
        HasAnyDuplicate() {
            return this.DuplicateSpectraCodes.length > 0 || this.DuplicateIgnitiaNGCodes.length > 0;
        },
        IsAnyFieldEmpty() {
            return this.UploadedSupplierRows.some(row =>
                this.IsEmptyField(row['Instance']) ||
                (this.IsEmptyField(row['Spectra Code']) && this.IsEmptyField(row['Ignitia/NG Code'])) ||
                (!this.IsEmptyField(row['Ignitia/NG Code']) && this.IsEmptyField(row['Ignitia/Payee Code']))
            );
        },
        ...mapGetters('supplierMapping', {
            SupplierMapping: 'SupplierMapping',
        }),
        CanAccessList() {
            return this.$store.getters.canAccessSupplierMappingManagement;
        },
        IsPaginationRequired() {
            return this.TotalRows != null && parseInt(this.TotalRows) > parseInt(this.perPage);
        },
    },
    filters: {
        formatDate(date) {
            return moment(date).isValid() ? moment(date).format("MM/DD/YYYY") : "-";
        },
    },
    watch: {
        activeTab: function (value) {
            if(value === 'Supplier Mapping'){
                this.GetAllSupplierMappings();
            }
        },
        RemovedCurrentFile(e) {
            if (e) {
                this.ShowUploadedTable = false;
                this.RemovedCurrentFile = false;
                this.ValidXLSDataAdded = false;
                this.UploadedSupplierRows = [];
            }
        },
        filter(e) {
            if ((e != null && e.length > 2) || e == null || e.length == 0) {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.currentPage = 1;
                    this.GetAllSupplierMappings();
                }, 500);
            }
        },
        currentPage: function (value) {
            if (value != null && parseInt(value) > 0) {
                this.GetAllSupplierMappings();
            }
        },
        perPage: function () {
            this.currentPage = 1;
            this.GetAllSupplierMappings();
        }
    },
    methods: {
        UploadedToDropzone() {
            if (this.$refs.excelUploadDropzone.dropzone.files.length > 0) {
                this.ExcelFileAdded = true;
            }
        },
        RemovedFromDropzone() {
            this.RemovedCurrentFile = true;
            this.ExcelFileAdded = false;
        },
        ClearBulkUploadData() {
            this.UploadedSupplierRows = [];
            this.ShowUploadedTable = false;
            this.ValidXLSDataAdded = false;
        },
        IsDuplicateField(value, key, row) {
            if (!value || !row || !row['Instance']) return false;
            const instance = row['Instance'].trim();
            const code = value.trim();
            if (key === 'Spectra Code') {
                return this.DuplicateSpectraCodes.includes(code + '|' + instance);
            } else if (key === 'Ignitia/NG Code') {
                return this.DuplicateIgnitiaNGCodes.includes(code + '|' + instance);
            }
            return false;
        },
        IsEmptyField(value) {
            return !value || value.trim().length === 0;
        },
        GetGridOptions() {
            return {
                PageSize: parseInt(this.perPage),
                CurrentPageNumber: parseInt(this.currentPage),
                FilterValue: this.filter,
                SortBy: this.sortBy,
                SortDesc: this.sortDesc,
            };
        },
        async downloadSupplierMappingUploadTemplate() {
            let file = {
                Name: "SupplierMappingUploadForm.xlsx",
            };
            this.$store
                .dispatch("supplierMapping/DownloadExcelUploadTemplate")
                .then((response) => {
                    const blob = new Blob([response.data], {
                        type: file.Extension,
                    });
                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(blob);
                    link.download = file.Name;
                    link.click();
                    URL.revokeObjectURL(link.href);
                })
                .catch((ex) => {
                    if (ex.response) {
                        this.$store.dispatch(
                            "progress/setErrorMessage",
                            `Error while downloading file. ${ex.response.data}`
                        );
                    } else {
                        this.$store.dispatch(
                            "progress/setErrorMessage",
                            `Error while downloading file. ${ex}`
                        );
                    }
                });
        },
        AddSupplierMappingFromExcel() {
            let columns = "";
            const schema = {
                "Instance": {
                    prop: "Instance",
                    type: String,
                },
                "Spectra Code": {
                    prop: "Spectra Code",
                    type: String,
                },
                "Ignitia/NG Code": {
                    prop: "Ignitia/NG Code",
                    type: String,
                },
                "Ignitia/Payee Code": {
                    prop: "Ignitia/Payee Code",
                    type: String,
                },
            };
            if (this.$refs.excelUploadDropzone.dropzone.files.length > 0) {
                if (
                    this.$refs.excelUploadDropzone.dropzone.files[0].name.indexOf(
                        ".xlsx"
                    ) > -1
                ) {
                    var file = this.$refs.excelUploadDropzone.dropzone.files[0];
                    readXlsxFile(file, {
                        schema,
                        transformData(data) {
                            if (data != null) columns = data.toString();
                            return data.filter(
                                (row) => row.filter((column) => column !== null).length > 0
                            );
                        },
                    }).then(({
                        rows
                    }) => {
                        if (
                    columns.indexOf("Instance") > -1 && columns.indexOf("Spectra Code") > -1 && columns.indexOf("Ignitia/NG Code") > -1 && columns.indexOf("Ignitia/Payee Code") > -1
                        ) {
                        this.MapUploadedFileData(rows);
                        this.ShowUploadedTable = true;
                        } else {
                        store.dispatch(
                            "progress/setErrorMessage",
                            `File format is not valid, it should contain 'Instance', 'Spectra Code', 'Ignitia/NG Code' and 'Ignitia/Payee Code' columns.`
                        );
                        }
                    });
                } else {
                    store.dispatch(
                        "progress/setErrorMessage",
                        `Only .xlsx file types are allowed`
                    );
                }
            } else {
                store.dispatch(
                    "progress/setErrorMessage",
                    `Please select .xlsx file to upload`
                );
            }
        },
        MapUploadedFileData(rows) {
            if (rows && rows.length > 0) {
                this.UploadedSupplierRows = rows;
                rows.forEach((item) => {
                    this.$set(this.SupplierMapping, "Instance", item["Instance"]);
                    this.$set(this.SupplierMapping, "SpectraCode", item["Spectra Code"]);
                    this.$set(this.SupplierMapping, "IgnitiaNGCode", item["Ignitia/NG Code"]);
                    this.$set(this.SupplierMapping, "PayeeCode", item["Ignitia/Payee Code"]);
                    this.AddSupplierMappingUploadedSupplierMapping();
                });
                this.$v.$touch();
                this.ValidXLSDataAdded = true;
            } else {
                store.dispatch("progress/setErrorMessage", `No valid data found in the uploaded Excel file.`);
            }
        },
        AddSupplierMappingUploadedSupplierMapping() {
            this.SupplierMappingData.rows.push({
                ...this.SupplierMapping,
            });
        },
        OpenFileUpload() {
            this.ShowExcelUpload = true;
        },
        CancelExcelUpload() {
            this.ShowExcelUpload = false;
            this.ShowUploadedTable = false;
            this.UploadedSupplierRows = [];
            this.ValidXLSDataAdded = false;
            this.SupplierMapping.Entity = null;
            this.SupplierMapping.IgnitiaNGCode = null;
            this.SupplierMapping.SpectraCode = null;
            this.SupplierMapping.PayeeCode = null;
        },
        sortChange(e) {
            this.sortBy = e.sortBy;
            this.sortDesc = e.sortDesc;
            this.GetAllSupplierMappings();
        },
        HidePopUpForm() {
            this.ShowSupplierMappingForm = false;
            this.IsEdit = false;
            this.SupplierMapping.Id = 0;
            this.SupplierMapping.Entity = null;
            this.SupplierMapping.IgnitiaNGCode = null;
            this.SupplierMapping.SpectraCode = null;
            this.SupplierMapping.PayeeCode = null;
            this.ValidXLSDataAdded = false;
        },
        EditSupplierMapping(item) {
            this.IsEdit = true;
            this.SupplierMapping.Id = parseInt(item.ID);
            this.SupplierMapping.Entity = item.Entity;
            this.SupplierMapping.IgnitiaNGCode = item.IgnitiaNGCode;
            this.SupplierMapping.SpectraCode = item.SpectraCode;
            this.SupplierMapping.PayeeCode = item.PayeeCode;
            this.ShowSupplierMappingForm = true;
        },
        ShowDeleteSupplierMappingConfirmation(item) {
            this.selectedSupplierMapping = item;
            this.ShowDeletionConfirmation = true;
        },
        DeleteSupplierMapping() {
            this.$store
            .dispatch('supplierMapping/DeleteSupplierMapping', parseInt(this.selectedSupplierMapping.ID))
            .then(() => {
                store.dispatch(
                        "progress/setSuccessMessage",
                        "Supplier Mapping has been deleted successfully!"
                    );
                    this.GetAllSupplierMappings();
            })
            .catch((ex) => {
                if (ex.response && [400, 403].includes(ex.response.status)) {
                    store.dispatch("progress/setErrorMessage", `${ex.response.data}`);
                }
                else {
                window.console.log(JSON.stringify(ex));
                    store.dispatch(
                        "progress/setErrorMessage",
                        "Error while deleting Supplier Mapping"
                    );
                }
            });
            this.Cancel();
        },
        Cancel() {
            this.ShowDeletionConfirmation = false;
            this.selectedSupplierMapping = null;
        },
        SubmitSupplierMappingForm() {
            this.$store
            .dispatch('supplierMapping/AddSupplierMapping', this.SupplierMapping)
            .then(() => {
                store.dispatch(
                        "progress/setSuccessMessage",
                        "Supplier Mapping has been added successfully!"
                    );
                    this.GetAllSupplierMappings();
            })
            .catch((ex) => {
                if (ex.response && [400, 403].includes(ex.response.status)) {
                    store.dispatch("progress/setErrorMessage", `${ex.response.data}`);
                }
                else {
                window.console.log(JSON.stringify(ex));
                    store.dispatch(
                        "progress/setErrorMessage",
                        "Error while adding Supplier Mapping"
                    );
                }
            });
            this.HidePopUpForm();
        },
        UpdateSupplierMappingForm() {
            this.$store
            .dispatch('supplierMapping/UpdateSupplierMapping', { id: this.SupplierMapping.Id, data: this.SupplierMapping })
            .then(() => {
                this.GetAllSupplierMappings();
                store.dispatch(
                        "progress/setSuccessMessage",
                        "Supplier Mapping has been updated successfully!"
                    );
            })
            .catch((ex) => {
                if (ex.response && [400, 403].includes(ex.response.status)) {
                    store.dispatch("progress/setErrorMessage", `${ex.response.data}`);
                }
                else {
                window.console.log(JSON.stringify(ex));
                    store.dispatch(
                        "progress/setErrorMessage",
                        "Error while updating Supplier Mapping"
                    );
                }
            });
            this.HidePopUpForm();
        },
        GetAllSupplierMappings() {
            this.TotalRows = 0;
            this.data.rows = [];
                this.$store
                .dispatch("supplierMapping/GetRequests", this.GetGridOptions())
                .then((res) => {
                    if (res.data) {
                        this.data.rows = res.data.Result;
                        this.TotalRows = res.data.Total;
                        this.RecordsPerPageOption = UpdateRecordsPerPageOption(this.TotalRows);
                    }
                })
                .catch((ex) => {
                    if (ex.response) {
                        this.$store.dispatch(
                            "progress/setErrorMessage",
                            `${ex.response.data}`
                        );
                    } else {
                        this.$store.dispatch(
                            "progress/setErrorMessage",
                            `Error fetching supplier mappings.${ex}`
                        );
                    }
                });
        },
        SubmitBulkUploadSupplierMapping() {
            const data = this.UploadedSupplierRows.map(row => ({
                ID: 0,
                Entity: row.Instance,
                SpectraCode: row['Spectra Code'],
                IgnitiaNGCode: row['Ignitia/NG Code'],
                PayeeCode: row['Ignitia/Payee Code'],
                IsDeleted: false,
                UpdatedBy: "",
                UpdatedDate: null
            }));
            this.$store
            .dispatch('supplierMapping/BulkUpload', data)
            .then(() => {
                store.dispatch(
                        "progress/setSuccessMessage",
                        "Supplier Mapping has been added successfully!"
                    );
                    this.ShowExcelUpload = false;
                    this.HidePopUpForm();
                    this.GetAllSupplierMappings();
                    this.ClearBulkUploadData();
            })
            .catch((ex) => {
                if(ex.status === 400 && ex.response && ex.response.data && ex.response.data.Errors.length > 0) {
                    this.ShowErrorPopUp = true;
                    this.ErrorList.push(...ex.response.data.Errors);
                }
                if (ex.response && [403].includes(ex.response.status)) {
                    store.dispatch("progress/setErrorMessage", `${ex.response.data}`);
                }
            });
        },
        CloseErrorPopUp() {
            this.ShowErrorPopUp = false;
            this.ErrorList = [];
        },
        template: function () {
            return `<div class="dz-preview dz-file-preview" style='background-color:#ffffff !important;display:flex;'>

                <div class="dz-details" style='margin-right:79px !important;'>
                    <div class="dz-size" style="display:none;" ><span data-dz-size></span></div>
                    <div class="FileforNewClientxls-Copy" style="margin-left:20px;width:280px;cursor:default !important;" ><span style='word-break:break-all !important;font-size:14px !important;font-weight:400;font-stretch:normal;font-style: normal;line-height: 0.71;color: #00a1d2 !important; font-family:"Open Sans" !important;' data-dz-name></span></div>
                </div>
                <a>
                 <img data-dz-remove=""  style='' src='/icons/fileremove.svg'  @click="DeleteServerFile()" ></img>
                </a>
            </div>`;
        },
    },
}
</script>
<style scoped>
.error-list-area {
    max-height: 300px;
    overflow-y: auto;
}
.xls-container .customdropzone.xls-dropzone .dz-preview.dz-file-preview{
    background-color: #ffffff !important;
    display: flex !important;
    justify-content: space-between !important;
    padding: 10px !important;
    border: 1px solid #ddd !important;
    border-radius: 0 0 10px 10px !important;
}
.modal-dialog.modal-md {
    min-width: 60% !important;
}
.xls-container .xls-section {
    width: 50%;
}

.upload-section.xls-section {
    background: #eff9fc;
    padding: 10px 10px 10px 10px;
    border-radius: 10px;
    box-shadow: 5px 4px 5px #00000012;
    border: 1px solid #dddddd;
}
.xls-container .xls-section .title {
    font-size: 18px;
    font-weight: bold;
}
.xls-container .xls-section ul li {
    margin-bottom: 12px;
    font-size: 13px;
}
.xls-container .xls-section ul li .number {
    background: #00a1d2;
    color: #ffffff;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    margin-right: 10px;
    font-size: 10px;
    font-weight: bold;
}
.xls-container .xls-section ul li a {
    background: #00a1d2;
    color: #ffffff;
    border-radius: 5px;
    padding: 5px 10px;
    font-weight: 600;
    cursor: pointer;
}
.Instance-list .floating-label-input {
    margin: 0;
}
.is-invalid {
    border-color: #dc3545 !important;
}
.xls-upload-table {
    max-height: 250px;
    overflow: hidden scroll;
}
.edit-supplier-mapping {
    display: flex;
    width: 20px;
    height: 7.5px;
    align-items: center;
}
.edit-supplier-mapping a {
    cursor: pointer;
}
.common-table .supplierMapping-table .table thead th {
    padding-left:15px !important;
}
.common-table .supplierMapping-table table tbody tr td {
    padding: 7.5px 15px !important;
}
.cancel-info-text {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.57;
    letter-spacing: normal;
    color: #47505a;
    padding-left: 20px;
}

.drag-and-drop-file-h {
    background-color: #ffffff;
    padding: 2px 0px 0px 2px;
    margin-bottom: 7.5px;
}
 .drag-and-drop-file-h img {
    opacity:0;
 }
.dropzone-custom-content,
.drag-and-drop-file-h,
.dz-message {
    height: 100% !important;
}

.draganddropspan {
    color: #00a1d2;
}

.supplier-upload-card section>label {
    text-transform: none;
    font-weight: 600;
}

.supplier-upload-card section>ol {
    margin-left: 1.5rem;
}

.customdropzone>.dz-preview dz-file-preview {
    border-top: dashed 2px #e9eef0 !important;
}

.customdropzone {
    border-radius: 8px !important;
    border: dashed 2px #e9eef0 !important;
    background-color: #ffffff !important;
    cursor: pointer !important;
    text-align: center;
    min-height: 50px;
}

.excel-file-upload-steps li {
    list-style: decimal;
}

.excel-file-upload-steps li a {
    color: #00a1d2 !important;
    cursor: pointer !important;
    border: none !important;
    padding: 0px;
}

.excel-file-upload-steps li a:hover {
    color: #00a1d2;
    opacity: 0.7;
    cursor: pointer !important;
}

.supplier-upload-card>.card-body {
    border-radius: 5px;
}
</style>